import React from "react";
import styles from "./consentDocuments.module.scss";

const ConsentDocumentsLayout = ({children, builder = false}: {children: React.ReactNode; builder?: boolean}) => {
  return <div className={`${styles.page} ${builder ? styles.builderPage : ""}`}>{children}</div>;
};

export default ConsentDocumentsLayout;
